export default __webpack_public_path__ + "static/media/new-arrivals.0e3e653b.jpeg";